import { c as _c } from "react/compiler-runtime";
import { LinkExternal01Icon } from '@systemeio/icons';
import EditTriggerWrapper from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper';
import { EditTriggerItemInterface } from 'modules/automation-rules/triggers/components/edit-triggers/types/edit-trigger-item-interface';
import { AutomationRuleTriggersDataEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { TriggerWebinarEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import React from 'react';
import { FormSelect } from 'shared/components';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface TriggerWebinarItemProps extends EditTriggerItemInterface<TriggerWebinarEditInterface> {}
const TriggerWebinarItem = t0 => {
  const $ = _c(18);
  const {
    triggers,
    trigger,
    idx,
    errors,
    onDelete,
    setRules,
    isStatic
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== errors.automationTriggers || $[4] !== idx || $[5] !== isStatic || $[6] !== setRules || $[7] !== t || $[8] !== trigger.id || $[9] !== trigger.webinar.id || $[10] !== trigger.webinar.registrationFunnelStep.funnel || $[11] !== trigger.webinar.registrationFunnelStep.name || $[12] !== triggers) {
    t2 = t3 => {
      const {
        data,
        renderTriggerLabel,
        onOpen
      } = t3;
      return <><FormSelect disabled={isStatic} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.registered_to_webinar)} required={true} label={renderTriggerLabel({
          label: t("dashboard.funnel.title"),
          additionalLabel: trigger.webinar.registrationFunnelStep.funnel.id ? <LinkWithoutPrefetch href={`/funnels/${trigger.webinar.registrationFunnelStep.funnel.id}`} rel="noreferrer" target="_blank" className="group self-center outline-hidden"><LinkExternal01Icon className="text-icon-tertiary transition-base group-focus-visible:text-icon-accent hover:text-icon-link-hover" /></LinkWithoutPrefetch> : undefined
        })} placeholder={t("dashboard.automation_rule.choose_funnel")} value={trigger.webinar.registrationFunnelStep.funnel.id} staticData={getDataFromObj(trigger.webinar.registrationFunnelStep.funnel)} data={data.funnelsWebinarData} onChange={data_0 => setRules(prev => ({
          ...prev,
          triggers: triggers.map((el, i) => {
            if (idx === i) {
              return {
                ...el,
                webinar: {
                  id: undefined,
                  registrationFunnelStep: {
                    funnel: {
                      id: data_0
                    }
                  }
                }
              };
            } else {
              return el;
            }
          })
        }))} error={errors.automationTriggers[trigger.id]?.funnel?.join("")} />{trigger.webinar.registrationFunnelStep.funnel.id && <FormSelect disabled={isStatic} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.registered_to_webinar_funnel_step)} label={t("dashboard.automation_rule.edit.webinar")} placeholder={t("dashboard.automation_rule.choose_webinar")} required={true} value={trigger.webinar.id} staticData={getDataFromObj({
          id: trigger.webinar.id,
          name: trigger.webinar.registrationFunnelStep.name
        })} data={data.webinarData} onChange={data_1 => setRules(prev_0 => ({
          ...prev_0,
          triggers: triggers.map((el_0, i_0) => {
            if (idx === i_0) {
              return {
                ...el_0,
                webinar: {
                  id: data_1,
                  registrationFunnelStep: {
                    funnel: trigger.webinar.registrationFunnelStep.funnel
                  }
                }
              };
            } else {
              return el_0;
            }
          })
        }))} error={errors.automationTriggers[trigger.id]?.funnelStep?.join("")} />}</>;
    };
    $[3] = errors.automationTriggers;
    $[4] = idx;
    $[5] = isStatic;
    $[6] = setRules;
    $[7] = t;
    $[8] = trigger.id;
    $[9] = trigger.webinar.id;
    $[10] = trigger.webinar.registrationFunnelStep.funnel;
    $[11] = trigger.webinar.registrationFunnelStep.name;
    $[12] = triggers;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== trigger) {
    t3 = <EditTriggerWrapper trigger={trigger} onDelete={t1}>{t2}</EditTriggerWrapper>;
    $[14] = t1;
    $[15] = t2;
    $[16] = trigger;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
};
export default TriggerWebinarItem;